<template>
  <v-container fluid grid-list-xl style="height:100%">
    <v-card raised style="height:100%">
      <v-container fluid grid-list-md style="height:100%">
        <v-layout row wrap style="height:100%">
          <v-flex xs12 style="height:10%; min-height:100px">
            <v-combobox
              v-model="report"
              :items="$store.state.reports[type]"
              :item-text="'name'"
              :item-value="'report'"
              label="Select a report to get some insights"
            ></v-combobox>
          </v-flex>
          <v-flex xs12 style="height:90%">
            <report
              :report="report"
              :reportService="reportService"
            ></report>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
  import Report from '@/components/Common/Report/Report'

  export default {
    props: {
      type: String,
      reportService: Object
    },

    components: {
      Report
    },

    data () {
      return {
        report: this.$store.state.reports[this.type].length ? this.$store.state.reports[this.type][0] : null
      }
    }
  }
</script>

<style lang="stylus">
  .clickable
    tr:hover
      cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/Common/Report/ReportList.vue